import { render, staticRenderFns } from "./WaitingAnswer.vue?vue&type=template&id=1d143ab5&"
import script from "./WaitingAnswer.vue?vue&type=script&lang=js&"
export * from "./WaitingAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports